import type { ReactNode } from 'react';

type Props = {
    title: string;
    headerAction?: ReactNode;
    children?: ReactNode;
};

export function ClientDetailsSection({ title, headerAction, children }: Props) {
    return (
        <section className="flex flex-col gap-1 border-t px-[var(--sheet-gutter)] py-4">
            <div className="flex items-center justify-between gap-2">
                <h2 className="text-lg font-semibold">{title}</h2>
                {headerAction}
            </div>
            {children}
        </section>
    );
}
